var map = {
	"./1.JPG": 441,
	"./10.JPG": 442,
	"./100.jpg": 443,
	"./101.jpg": 444,
	"./103.jpg": 445,
	"./104.jpg": 446,
	"./105.jpg": 447,
	"./106.jpg": 448,
	"./107.jpg": 449,
	"./108.jpg": 450,
	"./109.jpg": 451,
	"./11.JPG": 452,
	"./110.jpg": 453,
	"./111.png": 454,
	"./13.JPG": 455,
	"./14.JPG": 456,
	"./15.JPG": 457,
	"./16.JPG": 458,
	"./17.JPG": 459,
	"./18.JPG": 460,
	"./19.JPG": 461,
	"./2.JPG": 462,
	"./20.JPG": 463,
	"./21.JPG": 464,
	"./22.JPG": 465,
	"./23.JPG": 466,
	"./24.JPG": 467,
	"./25.JPG": 468,
	"./26.JPG": 469,
	"./27.JPG": 470,
	"./28.JPG": 471,
	"./29.JPG": 472,
	"./3.JPG": 473,
	"./4.JPG": 474,
	"./5.jpg": 475,
	"./6.JPG": 476,
	"./7.JPG": 477,
	"./8.JPG": 478,
	"./9.jpg": 479,
	"./camp.JPG": 480,
	"./challange.JPG": 481,
	"./challange1.jpg": 482,
	"./challange2.jpg": 483,
	"./crazygames.jpg": 484,
	"./facebook.svg": 485,
	"./facebook1.svg": 486,
	"./fair.JPG": 487,
	"./fair.png": 488,
	"./favicon.png": 489,
	"./gameof.JPG": 490,
	"./icon-menu.svg": 491,
	"./logo.png": 175,
	"./pleasure.JPG": 492,
	"./pleasure.png": 493,
	"./sprite1-w.png": 494,
	"./sprite2.png": 495,
	"./tents.jpg": 174
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;


//////////////////
// WEBPACK FOOTER
// ./src/style/Images ^\.\/.*$
// module id = 440
// module chunks = 0